import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { getOrderNotifications, markOrderNotificationsSeen } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";

const money = (v) => `$${(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const notify = (o) => {
  const label = { take_profit: "Take-profit", stop_loss: "Stop-loss", trailing_stop: "Trailing stop" }[o.order_type] || "Order";
  if (o.status === "filled") {
    const pnl = o.pnl || 0;
    toast.success(`${label} filled: ${o.symbol}`, {
      description: `${o.filled_shares} sh at ${money(o.fill_price)} · P&L ${pnl >= 0 ? "+" : "-"}${money(Math.abs(pnl))}`,
      duration: 12000,
      classNames: { description: "!text-bt-text-secondary" },
      id: `order-${o.id}`,
    });
  } else {
    toast(`${label} order on ${o.symbol} cancelled`, { description: o.reason, duration: 10000, id: `order-${o.id}`, classNames: { description: "!text-bt-text-secondary" } });
  }
};

export const OrderFillNotifier = () => {
  const { user } = useAuth();
  const busy = useRef(false);
  useEffect(() => {
    if (!user) return;
    const check = async () => {
      if (busy.current) return;
      busy.current = true;
      try {
        const { data } = await getOrderNotifications();
        if (data?.length) {
          data.forEach(notify);
          await markOrderNotificationsSeen(data.map(o => o.id));
          window.dispatchEvent(new Event("orders-changed"));
        }
      } catch {}
      busy.current = false;
    };
    check();
    const t = setInterval(check, 120000);
    return () => clearInterval(t);
  }, [user]);
  return null;
};
